// Group Class Attendance and Notes Modal Handling

document.addEventListener("turbolinks:load", () => {
  initializeAttendanceButtons();
  initializeInfoIcons();
});

function initializeAttendanceButtons() {
  // Handle attendance button clicks - only for buttons within attendance-buttonset
  $(document).on('click', '.attendance-buttonset .present-btn, .attendance-buttonset .no-show-btn, .attendance-buttonset .delete-btn', function(e) {
    e.preventDefault();
    
    const button = $(this);
    const registrationId = button.closest('.attendance-buttonset').data('registration-id');
    const action = button.hasClass('present-btn') ? 'present' : 
                   button.hasClass('no-show-btn') ? 'no_show' : 'delete';
    
    if (button.prop('disabled')) {
      return; // Don't process disabled buttons
    }
    
    handleAttendanceAction(registrationId, action, button);
  });
}

function handleAttendanceAction(registrationId, action, button) {
  const buttonset = button.closest('.attendance-buttonset');
  const groupClassId = buttonset.data('group-class-id');
  
  let url;
  if (action === 'delete') {
    // For delete, we need the attendance record ID
    const attendanceId = buttonset.data('attendance-id');
    if (!attendanceId) {
      alert('Error: Attendance record not found');
      return;
    }
    url = `/api/group_classes/${groupClassId}/registrations/${registrationId}/attendances/${attendanceId}`;
  } else {
    url = `/api/group_classes/${groupClassId}/registrations/${registrationId}/attendances`;
  }
  
  const method = action === 'delete' ? 'DELETE' : 'POST';
  const data = action === 'delete' ? {} : { status: action };
  
  $.ajax({
    url: url,
    method: method,
    data: data,
    headers: {
      'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
    },
    success: function(response, textStatus, xhr) {
      if (xhr.status === 204) {
        // DELETE successful - no content returned
        updateAttendanceButtons(registrationId, null);
      } else if (response && response.success) {
        updateAttendanceButtons(registrationId, response.data);
      } else {
        alert('Error: ' + (response.errors ? response.errors.join(', ') : 'Unknown error'));
      }
    },
    error: function(xhr) {
      alert('Error: ' + (xhr.responseJSON?.errors ? xhr.responseJSON.errors.join(', ') : 'Request failed'));
    }
  });
}

function updateAttendanceButtons(registrationId, attendanceData) {
  const buttonset = $(`.attendance-buttonset[data-registration-id="${registrationId}"]`);
  
  if (attendanceData.status === 'present') {
    buttonset.html(`
      <button class="btn btn-sm btn-outline-success present-btn" disabled>Present</button>
      <button class="btn btn-sm btn-outline-secondary delete-btn">×</button>
    `);
    // Store the attendance ID for delete operations
    buttonset.data('attendance-id', attendanceData.id);
  } else if (attendanceData.status === 'no_show') {
    buttonset.html(`
      <button class="btn btn-sm btn-outline-danger no-show-btn" disabled>No Show</button>
      <button class="btn btn-sm btn-outline-secondary delete-btn">×</button>
    `);
    // Store the attendance ID for delete operations
    buttonset.data('attendance-id', attendanceData.id);
  } else {
    // No attendance marked
    buttonset.html(`
      <button class="btn btn-sm btn-success present-btn">Present</button>
      <button class="btn btn-sm btn-danger no-show-btn">No Show</button>
    `);
    // Remove attendance ID since there's no attendance record
    buttonset.removeData('attendance-id');
  }
}

function initializeInfoIcons() {
  // Handle lesson info icon clicks
  $(document).on('click', '.lesson-info-icon', function(e) {
    e.preventDefault();
    const lessonId = $(this).data('lesson-id');
    showLessonDetails(lessonId);
  });
  
  // Handle group class info icon clicks
  $(document).on('click', '.group-class-info-icon', function(e) {
    e.preventDefault();
    const groupClassId = $(this).data('group-class-id');
    showGroupClassDetails(groupClassId);
  });
  
  // Handle notes button clicks
  $(document).on('click', '.notes-btn', function(e) {
    e.preventDefault();
    const element = $(this);
    const url = element.data('url');
    const title = element.data('title');
    
    if (url) {
      $.get(url, function(html) {
        if(html == 'invalid_request') {
          location.reload();
        } else {
          var modal = $('#global-modal');
          modal.find('.modal-title').html(title);
          modal.find('.modal-body').html(html);
          modal.modal("show");
        }
      });
    }
  });
}

function showLessonDetails(lessonId) {
  $.get(`/api/lessons/${lessonId}`, function(response) {
    if (response.success) {
      showDetailsModal('Lesson Details', response.data);
    } else {
      alert('Error loading lesson details');
    }
  }).fail(function() {
    alert('Error loading lesson details');
  });
}

function showGroupClassDetails(groupClassId) {
  $.get(`/api/group-classes/${groupClassId}`, function(response) {
    if (response.success) {
      showDetailsModal('Group Class Details', response.data);
    } else {
      alert('Error loading group class details');
    }
  }).fail(function() {
    alert('Error loading group class details');
  });
}

function showDetailsModal(title, data) {
  const modal = $('#global-modal');
  const modalTitle = modal.find('.modal-title');
  const modalBody = modal.find('.modal-body');
  
  // Create modal content
  const content = `
    <div class="details-modal">
      <div class="row">
        <div class="col-md-6">
          <h6>Instructor</h6>
          <p>${data.instructor.name}</p>
        </div>
        <div class="col-md-6">
          <h6>Student</h6>
          <p>${data.student.name}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <h6>Parent/Guardian</h6>
          <p>${data.user.name}</p>
        </div>
        <div class="col-md-6">
          <h6>Time</h6>
          <p>${data.time_slot.start} (${data.time_slot.duration})</p>
        </div>
      </div>
    </div>
  `;
  
  modalTitle.html(title);
  modalBody.html(content);
  modal.modal('show');
}
